import "./styles.scss";
import "moment/locale/pt";

import { API, Endpoints } from "utils/api";
import { Col, ConfigProvider, DatePicker, Drawer, Input, Row, Select, notification } from "antd";
import { UserPlaceholder, translate } from "utils/utils";
import { setBreadcrumb, setLoader, updateCrumb } from "store/actions";

import { DateTime } from "luxon";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import moment from "moment";
import pt from "antd/es/locale/pt_PT";
import { push } from "connected-react-router";

class Patient extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			patient: null,
			diagnostic: [],
			defaultDiagnostics: [],
			medication: false,
			medicationDescription: "",
			objectives: "",
			changed: false,
			changedTreatmentId: false,
			locale: pt
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.patients,
						route: "/patients"
					},
					{
						text: this.state.patient?.name || Strings.generic.loading,
						route: `/patients/${this.state.patient?._id || ""}`
					}
				]
			}))
		);

		this.getData();
	}

	componentDidUpdate() {
		const { dispatch } = this.props;
		dispatch(updateCrumb());
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		await Promise.all([this.getDiagnostics(), this.getPatient()]);

		dispatch(setLoader(false));
	}

	async getPatient() {
		const { match } = this.props;
		const {
			params: { id }
		} = match;

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriPatients(id)
			});

			if (response.ok) {
				const { patients: patient } = response.data.results || {};
				this.setState({ patient, ...patient, changed: false });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getDiagnostics() {
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriSkills()
			});

			if (response.ok) {
				const { diagnosis } = response.data.results || {};
				this.setState({ defaultDiagnostics: diagnosis });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async savePatient() {
		const { externalName, birthdate } = this.state;
		const { match, dispatch } = this.props;
		const {
			params: { id }
		} = match;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.put({
				url: Endpoints.uriProfile(`user/${id}`),
				data: {
					externalName,
					birthdate: birthdate ? moment.utc(birthdate).format("YYYY-MM-DD") : null
				}
			});

			if (response.ok) {
				await this.getPatient();

				notification.success({
					message: Strings.sidebar.patients,
					description: Strings.patients.saved,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async changeTreatment() {
		const { tempTreatment } = this.state;
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.put({
				url: Endpoints.uriPatients(tempTreatment.user, tempTreatment._id),
				data: tempTreatment
			});

			if (response.ok) {
				const { patients: patient } = response.data.results || {};
				this.setState({ patient, ...patient, changed: false, showDrawer: false, tempTreatment: null });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderPatientInfo() {
		const { name, business, photo, externalName, birthdate, changed, locale } = this.state;

		return (
			<div className="PatientInfo">
				<div className="PatientIdentifierBlock">
					<img src={photo || UserPlaceholder} alt="patient avatar" />
					<h3>{name || "-"}</h3>
					<p>{business || "Dummy"}</p>
				</div>
				<div className="PatientSeparator" />
				<div className="PatientOther">
					<div className="PatientInfoGrid">
						<div className="PatientInfoField">
							<label htmlFor="patient_othername" className="InputLabel">
								{Strings.patients.otherName}
							</label>
							<Input
								id="patient_othername"
								value={externalName || ""}
								className="ProfileInput"
								onChange={(e: any) => this.setState({ externalName: e.target.value, changed: true })}
								placeholder={Strings.patients.otherName}
							/>
						</div>
						<div className="PatientBirthdateField">
							<label htmlFor="patient_birthdate" className="InputLabel">
								{Strings.patients.birthdate}
							</label>
							<ConfigProvider locale={locale}>
								<DatePicker
									id="patient_birthdate"
									suffixIcon={<Icons.Calendar date color="blue" />}
									className="PatientFullWidth"
									value={birthdate ? moment.utc(birthdate) : null}
									format="DD-MM-YYYY"
									monthCellRender={(currentDate: any) => {
										return currentDate.format("MMM");
									}}
									onChange={(value: any) => {
										this.setState({ birthdate: value, changed: true });
									}}
								/>
							</ConfigProvider>
						</div>
					</div>
					<div className="PatientAction">
						<button disabled={!changed} onClick={() => this.savePatient()}>
							{Strings.generic.save}
						</button>
					</div>
				</div>
			</div>
		);
	}

	renderTreatments() {
		const { patient, defaultDiagnostics, treatments = [] } = this.state;
		const { match, dispatch, language } = this.props;
		const {
			params: { id }
		} = match;

		return (
			<React.Fragment>
				{treatments.map((treatment: any) => {
					return (
						<div key={`treatment_${treatment._id}`} className="PatientTreatments">
							<div className="TreatmentHeader">
								<p></p>
								<button onClick={() => this.setState({ showDrawer: true, tempTreatment: treatment })}>
									<Icons.Pencil />
									<p>{Strings.fields.edit}</p>
								</button>
							</div>
							<Row gutter={[50, 20]}>
								<Col xs={24}>
									<Row gutter={[50, 0]}>
										<Col xs={24} md={16}>
											<label htmlFor="patient_diagnostics" className="InputLabel">
												{Strings.patients.diagnostics}
											</label>
											<Select
												id="patient_diagnostics"
												className="tagsSelector PatientFullWidth"
												placeholder={Strings.patients.diagnostics}
												showSearch
												disabled
												mode="multiple"
												filterOption={(input: any, option: any) =>
													option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
												}
												value={treatment?.diagnostics}
											>
												{defaultDiagnostics.map((tmpDiagnostic: any) => (
													<Select.Option
														key={`diagnostic_option_${tmpDiagnostic._id}`}
														value={tmpDiagnostic._id}
													>
														{translate(tmpDiagnostic?.name)}
													</Select.Option>
												))}
											</Select>
										</Col>
										<Col xs={24} md={8}>
											<div className="PatientDischarge">
												<label htmlFor="patient_clinical_discharge" className="InputLabel">
													{Strings.patients.clinicalDischarge}
												</label>
												<Input
													id="patient_clinical_discharge"
													value={
														(Boolean(treatment.clinicalDischarge) &&
															`${DateTime.fromISO(treatment.clinicalDischarge)
																.setLocale(language)
																.toFormat("dd MMMM yyyy - HH:mm")}`) ||
														""
													}
													className="ProfileInput"
													readOnly
													placeholder={Strings.patients.clinicalDischarge}
												/>
											</div>
										</Col>
									</Row>
								</Col>
								<Col xs={16}>
									<div className="PatientMedication">
										<div>
											<label htmlFor="patient_medication_bool" className="InputLabel">
												{Strings.patients.takeMeds}
											</label>
											<div id="patient_medication_bool" className="PatientMedsButtons">
												<button
													className={`PatientButton${
														!treatment?.medication && " --btn-active"
													}`}
												>
													{Strings.generic.no}
												</button>
												<button
													className={`PatientButton${
														treatment?.medication && " --btn-active"
													}`}
												>
													{Strings.generic.yes}
												</button>
											</div>
										</div>
										<div className="PatientMedicationList">
											<label htmlFor="patient_medication" className="InputLabel">
												{Strings.patients.meds}
											</label>
											<Input
												id="patient_medication"
												value={treatment?.medicationDescription || ""}
												className="ProfileInput"
												readOnly
												placeholder={Strings.patients.meds}
											/>
										</div>
									</div>
								</Col>
								<Col xs={16}>
									<label htmlFor="patient_treatment" className="InputLabel">
										{Strings.patients.objective}
									</label>
									<Input.TextArea
										id="patient_treatment"
										value={treatment?.goals || ""}
										className="ProfileInput"
										rows={4}
										readOnly
										placeholder={Strings.patients.objective}
									/>
								</Col>
								<Col xs={24}>
									<Row gutter={[50, 20]}>
										<Col xs={24} md={16}>
											<label htmlFor="patient_treatment_anamnesis" className="InputLabel">
												{Strings.reports.anamnese}
											</label>
											<Input.TextArea
												id="patient_treatment_anamnesis"
												value={treatment?.anamnesis || ""}
												className="ProfileInput"
												rows={4}
												readOnly
												placeholder={Strings.reports.anamnese}
											/>
										</Col>
										<Col xs={24} md={8}>
											<div className="PatientTreatmentDetails">
												<a
													href={`/patients/${id}/treatment/${treatment._id}`}
													target="_blank"
													rel="noopener noreferrer"
													onClick={(e: any) => {
														e.preventDefault();
														e.stopPropagation();

														dispatch(
															push(`/patients/${id}/treatment/${treatment._id}`, {
																patient
															})
														);
													}}
												>
													{Strings.patients.details}
												</a>
											</div>
										</Col>
									</Row>
								</Col>
							</Row>
						</div>
					);
				})}
				{treatments.length === 0 && <p>{Strings.patients.noTreatments}</p>}
			</React.Fragment>
		);
	}

	renderTreatmentDrawerContent() {
		const { tempTreatment, defaultDiagnostics } = this.state;

		return (
			<Row gutter={[0, 20]}>
				<Col xs={24}>
					<label htmlFor="patient_diagnostics" className="InputLabel">
						{Strings.patients.diagnostics}
					</label>
					<Select
						id="patient_diagnostics"
						className="tagsSelector PatientFullWidth"
						placeholder={Strings.patients.diagnostics}
						showSearch
						mode="multiple"
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						value={tempTreatment?.diagnostics}
						onChange={(value: any) =>
							this.setState((prevState: any) => ({
								tempTreatment: { ...prevState.tempTreatment, diagnostics: value }
							}))
						}
					>
						{defaultDiagnostics.map((tmpDiagnostic: any) => (
							<Select.Option key={`diagnostic_option_${tmpDiagnostic._id}`} value={tmpDiagnostic._id}>
								{translate(tmpDiagnostic?.name)}
							</Select.Option>
						))}
					</Select>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_medication_bool" className="InputLabel">
						{Strings.patients.takeMeds}
					</label>
					<div id="report_medication_bool" className="TreatmentMedsButtons">
						<button
							className={`PatientButton${!tempTreatment?.medication && " --btn-active"}`}
							onClick={() =>
								this.setState((prevState: any) => ({
									tempTreatment: { ...prevState.tempTreatment, medication: false }
								}))
							}
						>
							{Strings.generic.no}
						</button>
						<button
							className={`PatientButton${tempTreatment?.medication && " --btn-active"}`}
							onClick={() =>
								this.setState((prevState: any) => ({
									tempTreatment: { ...prevState.tempTreatment, medication: true }
								}))
							}
						>
							{Strings.generic.yes}
						</button>
					</div>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_meds_description" className="InputLabel">
						{Strings.patients.meds}
					</label>
					<Input
						id="report_meds_description"
						value={tempTreatment?.medicationDescription || ""}
						className="TreatmentTextarea"
						placeholder={Strings.patients.meds}
						disabled={!tempTreatment?.medication}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempTreatment: { ...prevState.tempTreatment, medicationDescription: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_goals" className="InputLabel">
						{Strings.patients.objective}
					</label>
					<Input.TextArea
						id="report_goals"
						value={tempTreatment?.goals || ""}
						className="TreatmentTextarea"
						rows={6}
						placeholder={Strings.patients.objective}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempTreatment: { ...prevState.tempTreatment, goals: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_intervention" className="InputLabel">
						{Strings.reports.anamnese}
					</label>
					<Input.TextArea
						id="report_anamnese"
						className="TreatmentTextarea PatientAnamnesisInput"
						value={tempTreatment?.anamnesis || ""}
						rows={6}
						placeholder={Strings.reports.anamnese}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempTreatment: { ...prevState.tempTreatment, anamnesis: value }
							}));
						}}
					/>
				</Col>
			</Row>
		);
	}

	renderTreatmentDrawer() {
		const { showDrawer } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.reports.header}</h2>}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempTreatment: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.changeTreatment()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false, tempTreatment: null })}
			>
				{this.renderTreatmentDrawerContent()}
			</Drawer>
		);
	}

	render() {
		const { patient } = this.state;
		const { mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>
						{Strings.sidebar.patients} - {patient?.name || Strings.generic.loading} | Team24
					</title>
					<meta name="description" content="Description of Patient" />
				</Helmet>
				<div className="PatientContent">
					<h1 className="GenericTitle">{Strings.patients.clinicalRecord}</h1>
					{this.renderPatientInfo()}
					<h1 className="GenericTitle --margin-top">{Strings.patients.treatments}</h1>
					{this.renderTreatments()}
				</div>
				{mobile && <Footer />}
				{this.renderTreatmentDrawer()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	mobile: state.mobile
});

export default connect(mapStateToProps)(Patient);
